// extracted by mini-css-extract-plugin
export default {"navbarBrand":"Layout_navbarBrand__zxqZX","navLink":"Layout_navLink__+7Z0n","logo":"Layout_logo__E+6TJ","footerLogo":"Layout_footerLogo__RDmGZ"};